import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TDSPPageTitle } from 'utility/constants';

const PageTitle = ({ title }: { title?: string }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = !title ? TDSPPageTitle : `${TDSPPageTitle} | ${title}`;
  }, [location, title]);

  return null;
};

export default PageTitle;
